import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/logOnlyInProduction";
import thunk from "redux-thunk";
import { DiscountState } from "./discount/discount.types";
import { EngineState } from "./engine/engine.types";
import { IntermediarioState } from "./intermediario/intermediario.types";
import { discountReducer } from "./discount/discountReducer";
import { engineReducer } from "./engine/engineReducer";
import { intermediarioReducer } from "./intermediario/intermediarioReducer";
import { ProdottoState } from "./prodotto/prodotto.types";
import { prodottoReducer } from "./prodotto/prodottoReducer";

export interface IAction<T = any, M = any, E = any> {
  type: string;
  payload?: T;
  meta?: M;
  error?: E;
}

export interface IStore {
  discount: DiscountState;
  intermediario: IntermediarioState;
  engine: EngineState;
  prodotto: ProdottoState;
}

export const rootReducer = (state: IStore | undefined, action: IAction): IStore =>
  combineReducers({
    discount: discountReducer,
    intermediario: intermediarioReducer,
    engine: engineReducer,
    prodotto: prodottoReducer,
  })(state, action);

export const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));
